import { render } from "./SidebarContainer.vue?vue&type=template&id=0fb7efaa&scoped=true"
import script from "./SidebarContainer.vue?vue&type=script&lang=js"
export * from "./SidebarContainer.vue?vue&type=script&lang=js"

import "./SidebarContainer.vue?vue&type=style&index=0&id=0fb7efaa&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/plus.centrodeglaucoma.com/darmin-plus/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fb7efaa"]])

export default __exports__